// ─── Sprung zu einer Person ──────────────────────────────────────────────────
//
// Die Rechnung hinter „zeig mir diese Person": aus der Position im Layout und
// der Größe der Zeichenfläche wird die Verschiebung, die sie in die Mitte holt.
//
// Eigene Datei, weil sie sich so prüfen lässt – im Bauteil steckt sie zwischen
// d3-Übergängen und Verweisen auf DOM-Knoten und ist dort nicht zu fassen.

export interface Punkt {
  x: number;
  y: number;
}

export interface Flaeche {
  breite: number;
  hoehe: number;
}

export interface Ansicht {
  x: number;
  y: number;
  k: number;
}

/**
 * Die Ansicht, die `ziel` in die Mitte von `flaeche` rückt.
 *
 * Die Zoomstufe bleibt, wie sie ist – wer nah dran war, bleibt nah dran. Nur
 * aus sehr weiter Sicht wird auf ein lesbares Maß gegangen: bei 15 % ist eine
 * Karte ein Strich, und ein Sprung dorthin sähe aus wie gar nichts.
 */
export function sprungAnsicht(
  ziel: Punkt,
  flaeche: Flaeche,
  aktuellerZoom: number,
  mindestZoom = 0.6,
): Ansicht {
  const k = Math.max(aktuellerZoom, mindestZoom);
  return {
    k,
    x: flaeche.breite / 2 - ziel.x * k,
    y: flaeche.hoehe / 2 - ziel.y * k,
  };
}
